import { FileManagerApi, ReportType } from "../Api";
import { getAuthConfiguration } from "./configuration";

const ApiFactory = () => new FileManagerApi(getAuthConfiguration());

export const uploadReportFile = (id: string, type: ReportType, file: Blob) => {
    return ApiFactory().apiFileManagerUploadReportIdTypePost({ id, type, file });
}

export const downloadReportFile = (id: string, reportType: ReportType) => {
    return ApiFactory().apiFileManagerDownloadReportIdGet({ id, type: reportType });
}

